import { render, staticRenderFns } from "./TeacherPassword.vue?vue&type=template&id=f4768ef2&scoped=true&"
import script from "./TeacherPassword.vue?vue&type=script&lang=js&"
export * from "./TeacherPassword.vue?vue&type=script&lang=js&"
import style0 from "./TeacherPassword.vue?vue&type=style&index=0&id=f4768ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4768ef2",
  null
  
)

export default component.exports